import PropTypes from 'prop-types'
import { useCallback, useState, useEffect } from 'react'
import { useDropzone } from 'react-dropzone'
import { sanitizeImageUrl } from '../../helpers/sanitizeUrl.js'
import * as publicacionesService from '../servicios/publicacionesService'
import * as publicacionesTemporalesService from '../servicios/publicacionesTemporalesService'
import LinkButton from '../ui/LinkButton'

const Upload = ({ idPublicacion, idPublicacionTemporal, accept }) => {
  const [adjuntosImg, setAdjuntosImg] = useState([])
  const [adjuntosId, setAdjuntosId] = useState([])
  const imagenesP = new Array()
  const imagenesI = new Array()
  const [reload, setReload] = useState(false)

  // Función para obtener y validar idUsuario del localStorage
  const getValidUserId = () => {
    const userId = localStorage.getItem('idUsuario')
    // Validar que sea un número válido y positivo
    const parsedId = parseInt(userId, 10)
    if (isNaN(parsedId) || parsedId <= 0 || !Number.isInteger(parsedId)) {
      return 0
    }
    return parsedId
  }

  useEffect(() => {
    if (idPublicacion > 0 || idPublicacionTemporal > 0) {
      obtenerAdjuntos()
    }
    setReload(false)
  }, [idPublicacion, idPublicacionTemporal, reload])

  const obtenerAdjuntos = async () => {
    let imagenes
    if (idPublicacion > 0) {
      imagenes = await publicacionesService.buscarAdjuntos(idPublicacion)
    } else {
      imagenes =
        await publicacionesTemporalesService.buscarAdjuntos(idPublicacionTemporal)
    }

    obtenerImagen(imagenes.data)
  }

  const obtenerImagen = async (adjuntos) => {
    if (adjuntos.length > 0) {
      const userId = getValidUserId()
      if (userId === 0) {
        return
      }

      adjuntos.forEach(async (a) => {
        const { data: imagen } =
          idPublicacion > 0
            ? await publicacionesService.BuscarImagenPorAdjunto(
                userId,
                idPublicacion,
                a.idAdjunto
              )
            : await publicacionesTemporalesService.BuscarImagenPorAdjunto(
                userId,
                idPublicacionTemporal,
                a.idAdjunto
              )

        const imagenUrl = URL.createObjectURL(imagen)
        imagenesP.push(imagenUrl)
        imagenesI.push({ idAdjunto: a.idAdjunto })
        setAdjuntosImg([...imagenesP])
        setAdjuntosId([...imagenesI])
      })
    } else {
      setAdjuntosImg([])
      setAdjuntosId([])
    }
  }

  const onDrop = useCallback(
    (acceptedFiles) => {
      acceptedFiles.map((archivo) => {
        upload(idPublicacion, idPublicacionTemporal, archivo).then(() => {})
        return archivo
      })
    },
    [idPublicacion, idPublicacionTemporal]
  )

  const { getRootProps, getInputProps, isDragActive } = useDropzone({ onDrop, accept })

  const upload = async (idPublicacion, idPublicacionTemporal, archivo) => {
    const userId = getValidUserId()
    if (userId === 0) {
      return
    }

    const datosForm = new FormData()
    datosForm.append('nombre', archivo.name)
    datosForm.append('idPublicacion', idPublicacion)
    datosForm.append('idPublicacionTemporal', idPublicacionTemporal)
    datosForm.append('registroAddUsr', userId)
    datosForm.append('archivo', archivo)

    if (idPublicacion > 0) {
      await publicacionesService.subirAdjunto(datosForm)
    } else {
      await publicacionesTemporalesService.subirAdjunto(datosForm)
    }
    setReload(true)
  }

  const borrarArchivo = async (e, idAdjunto) => {
    const userId = getValidUserId()
    if (userId === 0) {
      return
    }

    setAdjuntosId(adjuntosId.filter((a) => a.idAdjunto !== idAdjunto))
    if (idPublicacion > 0) {
      await publicacionesService.eliminarAdjunto(userId, idPublicacion, idAdjunto)
    } else {
      await publicacionesTemporalesService.eliminarAdjunto(
        userId,
        idPublicacionTemporal,
        idAdjunto
      )
    }
    setReload(true)
  }

  return (
    <>
      <div className="borde-hormiga text-center" {...getRootProps()}>
        <i className="fa fa-camera fa-2x" aria-hidden="true" />
        <input {...getInputProps()} />
        {isDragActive ? <p>Arrastralas acá...</p> : <p>Agregalas desde tu computadora</p>}
      </div>
      <div className="row-img-subida">
        <div className="row">
          {adjuntosId &&
            adjuntosId.map((a, index) => (
              <div className="col-6 col-xl-3" key={index}>
                <div className="row">
                  <div className="col-12">
                    <div className="cont-img-subida">
                      <LinkButton
                        onClick={(e) => borrarArchivo(e, a.idAdjunto)}
                        className="btn"
                      >
                        <i className="fa fa-times eliminar-img" aria-hidden="true" />
                      </LinkButton>
                      <img
                        alt={`img-${index}`}
                        src={sanitizeImageUrl(adjuntosImg[index])}
                        className="subida-img"
                      />
                    </div>
                  </div>
                </div>
              </div>
            ))}
        </div>
      </div>
    </>
  )
}

Upload.propTypes = {
  idPublicacion: PropTypes.number.isRequired,
  idPublicacionTemporal: PropTypes.number.isRequired,
  accept: PropTypes.object.isRequired
}

export default Upload
